module.exports = __webpack_public_path__ + "static/media/dec-maintenance-large.25345972.jpg";